import { SETTINGS_COMPANY_HIDE_NON_DELEGATE_DOMAIN_SETUP } from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsYandexCloud = () =>
    useSettingsFactory({
        hideNonDelegateDomainSetup: {
            path: SETTINGS_COMPANY_HIDE_NON_DELEGATE_DOMAIN_SETUP,
        },
    });
